export var PostOrderStatus;
(function (PostOrderStatus) {
    PostOrderStatus[PostOrderStatus["UNPOSTED"] = 1] = "UNPOSTED";
    PostOrderStatus[PostOrderStatus["POSTED"] = 2] = "POSTED";
})(PostOrderStatus || (PostOrderStatus = {}));
//# sourceMappingURL=post-order-status.js.map